import { render, staticRenderFns } from "./PdfIcon.vue?vue&type=template&id=e4e635fe&"
import script from "./PdfIcon.vue?vue&type=script&lang=js&"
export * from "./PdfIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports